// removed by extract-text-webpack-plugin
module.exports = {"content":"MyProfile__content__1jGMf","parentContainer":"MyProfile__parentContainer__206xX","qrWrapper":"MyProfile__qrWrapper__3BAMK","alertStyle":"MyProfile__alertStyle__1tWl0","profileDetailsWrappers":"MyProfile__profileDetailsWrappers__2lBhM","notificationGroup":"MyProfile__notificationGroup__19fkC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyProfile/MyProfile.css
// module id = 2916
// module chunks = 0